import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
  Grid,
  Box,
  Skeleton,
  Divider,
} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { getStatusColor, MONTHS } from "../PayrollMgLandingPage";
const MonthTileView = ({
  userRole,
  filters,
  handleFilter,
  paySummaryTileData,
  handleMonthClick,
  currentType = "Regular",
}) => {
  const { payrollTileViewLoading } = useSelector(
    (state) => state.FinanceReducer?.PayrollManagementReducer
  );
  const statusKey = `${currentType}_status`;
  const activeTiles = paySummaryTileData?.filter(
    (monthData) => monthData?.[statusKey] && monthData?.[statusKey] !== "Pending Generation"
  );
  const pendingTiles = paySummaryTileData?.filter(
    (monthData) => monthData?.[statusKey] === "Pending Generation"
  );
  return (
    <Box>
     { activeTiles?.length > 0 && <>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Active Payroll Months
        </Typography>
        <Grid container spacing={2}>
          {payrollTileViewLoading
            ? Array.from({ length: 12 }).map((_, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={`skeleton-${idx}`}>
                  <Card sx={{ height: 95, p: 1 }}>
                    <Skeleton
                      variant="rectangular"
                      height={32}
                      sx={{ mb: 1, borderRadius: 1 }}
                    />
                    <Skeleton
                      variant="rounded"
                      height={28}
                      width="60%"
                      sx={{ mb: 1 }}
                    />
                  </Card>
                </Grid>
              ))
            : activeTiles?.map((monthData, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={`month-${monthData?.month}`}
                >
                  <Card
                    onClick={() => handleMonthClick(monthData?.month, monthData)}
                    sx={{
                      cursor: "pointer",
                      height: 95,
                    }}
                  >
                    <CardHeader
                      title={
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Box display="flex" alignItems="center" gap={1}>
                            <CalendarToday fontSize="small" color="disabled" />
                            <Typography variant="h6">
                              {MONTHS[monthData?.month]}
                            </Typography>
                          </Box>
                          <Box>{filters?.year_only}</Box>
                        </Box>
                      }
                      sx={{ py: 1.5, px: 2 }}
                    />
                    <CardContent sx={{ pt: 0, px: 2 }}>
                      <Box display="flex" justifyContent={"flex-end"} gap={1}>
                        <Box>
                          <Chip
                            label={monthData?.[statusKey]}
                            sx={{
                              backgroundColor: getStatusColor(monthData?.[statusKey])?.bg,
                              color: getStatusColor(monthData?.[statusKey])?.text,
                              fontWeight: 500,
                            }}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
        </Grid>
      </>}

      <Divider sx={{ my: 2 }} />
      {/* pending section */}
      { pendingTiles?.length > 0 &&
      <>
        <Typography variant="h6" sx={{ mb: 2 }}>
            Pending Generation
          </Typography>
        <Grid container spacing={2}>
          {payrollTileViewLoading
            ? Array.from({ length: 12 }).map((_, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={`skeleton-${idx}`}>
                  <Card sx={{ height: 95, p: 1 }}>
                    <Skeleton
                      variant="rectangular"
                      height={32}
                      sx={{ mb: 1, borderRadius: 1 }}
                    />
                    <Skeleton
                      variant="rounded"
                      height={28}
                      width="60%"
                      sx={{ mb: 1 }}
                    />
                  </Card>
                </Grid>
              ))
            : pendingTiles?.map((monthData, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={`month-${monthData?.month}`}
                >
                  <Card
                    onClick={() => handleMonthClick(monthData?.month, monthData)}
                    sx={{
                      cursor: "pointer",
                      height: 95,
                    }}
                  >
                    <CardHeader
                      title={
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Box display="flex" alignItems="center" gap={1}>
                            <CalendarToday fontSize="small" color="disabled" />
                            <Typography variant="h6">
                              {MONTHS[monthData?.month]}
                            </Typography>
                          </Box>
                          <Box>{filters?.year_only}</Box>
                        </Box>
                      }
                      sx={{ py: 1.5, px: 2 }}
                    />
                    <CardContent sx={{ pt: 0, px: 2 }}>
                      <Box display="flex" justifyContent={"flex-end"} gap={1}>
                        <Box>
                          <Chip
                            label={monthData?.[statusKey]}
                            sx={{
                              backgroundColor: getStatusColor(monthData?.[statusKey])?.bg,
                              color: getStatusColor(monthData?.[statusKey])?.text,
                              fontWeight: 500,
                            }}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
        </Grid>
      </>
      }
    </Box>
  );
};

export default MonthTileView;
